import { forwardRef, useContext, useEffect, useImperativeHandle, useMemo, useState } from "react"
import { AvatarContext } from "@/components/RenderComp/Avatar"
import { RESOURCE_MANAGER } from "@/config"
import FUIcon from "../../../Common/FUIcon"

const AvatarsTabContent = forwardRef<any, any>((props, ref) => {
    const { interrupt } = props
    const { scheduleUpdateAvatar, avatarConfig } = useContext(AvatarContext)

    const selectedAvatarId = useMemo(() => {
        return avatarConfig?.avatar_id
    }, [avatarConfig?.avatar_id])

    const handleSelectAvatar = async (avatarConfig) => {
        if (avatarConfig.avatar_id === selectedAvatarId) {
            return;
        }
        if (interrupt) {
            await interrupt()
        }
        await scheduleUpdateAvatar(avatarConfig)
    }

    const [storageAvatarList, setStorageAvatarList] = useState([])
    const getStorageAvatarList = () => {
        const jsonstring = window.localStorage.getItem('avatarList') || '[]'
        setStorageAvatarList(JSON.parse(jsonstring))
    }

    useEffect(() => {
        getStorageAvatarList()
    }, [])

    const avatarList = useMemo(() => {
        return [...RESOURCE_MANAGER.defaultAvatarList, ...storageAvatarList]
    }, [storageAvatarList])
    const selectedAvatar = useMemo(() => {
        return avatarList.find(
            i => i.avatar_id === selectedAvatarId
        )
    }, [avatarList, selectedAvatarId])
    useImperativeHandle(ref, () => {
        return {
            avatarList,
            selectedAvatar,
            selectedAvatarId,
            getStorageAvatarList
        }
    })

    return (
        <div className="avatar-list better-scroll">
            {
                avatarList.map((avatar) => {
                    return (
                        <div
                            key={avatar.avatar_id}
                            className={
                                'component component-avatar ' + (
                                    avatar.avatar_id === selectedAvatarId
                                        ? 'active'
                                        : ''
                                )
                            }
                            onClick={() => handleSelectAvatar(avatar)}
                        >
                            <FUIcon
                                name={avatar.icon_full_url}
                            />
                        </div>
                    )
                })
            }
        </div>
    )
})

export default AvatarsTabContent
